import React, { useState, useCallback, memo } from 'react';
import { formatDate, formatDateKey } from '../../../utils/date-utils';

function JobDateGroup({ 
  date, 
  jobs, 
  renderJobCard
}) {
  const [isExpanded, setIsExpanded] = useState(true);
  
  // Format the date for display
  const formattedDate = formatDate(date);
  
  const toggleExpand = useCallback(() => {
    setIsExpanded(prevState => !prevState);
  }, []);
  
  // Don't render if there are no jobs
  if (!jobs || jobs.length === 0) return null;
  
  return (
    <div className="mb-4">
      <div 
        className="flex items-center justify-between bg-gray-50 px-4 py-2 rounded-lg cursor-pointer"
        onClick={toggleExpand}
      >
        <div className="flex items-center">
          <span className="inline-block w-5 h-5 text-gray-400 mr-2 text-center">
            {isExpanded ? '▼' : '▶'}
          </span>
          <h3 className="text-lg font-medium text-gray-900">{formattedDate}</h3>
        </div>

      </div>
      
      {isExpanded && (
        <div className="mt-2 space-y-2">
          {jobs.map((job, index) => renderJobCard(job, index))}
        </div>
      )}
    </div>
  );
}

export default memo(JobDateGroup); 